import { customerConstants } from "../@_constants/customer.constants";

const initialState = {
  verification_data: {},
  case_tags: [],
  credits: 0,
  status: {
    VERIFICATION_EMAIL: "",
    CUSTOMER_VERIFICATION: "",
    PAYMENT_REPORT: "",
    PAYMENT_REPORT_DETAILS: "",
    CASES_REPORT: "",
    EMAIL_CONTENT: "",
    CASE_TAGS: "",
    CREDITS: "",
    ADD_CREDITS: "",
  },
};

export function customerReducer(state = initialState, action) {
  switch (action.type) {
    case customerConstants.USER_CLEAR_STATUS_MESSAGE:
      state = {
        ...state,
        status: { ...state.status, [action.stateName]: "" },
      };
      break;

    // CUSTOMER VERIFICATION EMAIL POST REQUEST
    case customerConstants.CUSTOMER_VERIFICATION_EMAIL_REQUEST:
      state = {
        ...state,
        status: { ...state.status, VERIFICATION_EMAIL: "request" },
      };
      break;
    case customerConstants.CUSTOMER_VERIFICATION_EMAIL_SUCCESS:
      state = {
        ...state,
        status: { ...state.status, VERIFICATION_EMAIL: "success" },
      };

      break;
    case customerConstants.CUSTOMER_VERIFICATION_EMAIL_FAILURE:
      state = {
        ...state,
        status: { ...state.status, VERIFICATION_EMAIL: action.error },
      };
      break;
    // CUSTOMER VERIFICATION PUT REQUEST
    case customerConstants.CUSTOMER_VERIFICATION_PUT_REQUEST:
      state = {
        ...state,
        status: { ...state.status, CUSTOMER_VERIFICATION: "request" },
      };
      break;
    case customerConstants.CUSTOMER_VERIFICATION_PUT_SUCCESS:
      state = {
        ...state,
        verification_data: action.data,
        status: { ...state.status, CUSTOMER_VERIFICATION: "success" },
      };

      break;
    case customerConstants.CUSTOMER_VERIFICATION_PUT_FAILURE:
      state = {
        ...state,
        status: { ...state.status, CUSTOMER_VERIFICATION: action.error },
      };
      break;

    // CUSTOMER PAYMENT REPORT GET REQUEST
    case customerConstants.CUSTOMER_GET_PAYMENT_REPORT_REQUEST:
      state = {
        ...state,
        status: { ...state.status, PAYMENT_REPORT: "request" },
      };
      break;
    case customerConstants.CUSTOMER_GET_PAYMENT_REPORT_SUCCESS:
      state = {
        ...state,
        status: { ...state.status, PAYMENT_REPORT: "success" },
      };

      break;
    case customerConstants.CUSTOMER_GET_PAYMENT_REPORT_FAILURE:
      state = {
        ...state,
        status: { ...state.status, PAYMENT_REPORT: action.error },
      };
      break;

    // CUSTOMER PAYMENT REPORT DETAILS GET REQUEST
    case customerConstants.CUSTOMER_GET_PAYMENT_REPORT_DETAILS_REQUEST:
      state = {
        ...state,
        status: { ...state.status, PAYMENT_REPORT_DETAILS: "request" },
      };
      break;
    case customerConstants.CUSTOMER_GET_PAYMENT_REPORT_DETAILS_SUCCESS:
      state = {
        ...state,
        status: { ...state.status, PAYMENT_REPORT_DETAILS: "success" },
      };

      break;
    case customerConstants.CUSTOMER_GET_PAYMENT_REPORT_DETAILS_FAILURE:
      state = {
        ...state,
        status: { ...state.status, PAYMENT_REPORT_DETAILS: action.error },
      };
      break;

    // CUSTOMER CASES REPORT GET REQUEST
    case customerConstants.CUSTOMER_GET_CASES_REPORT_REQUEST:
      state = {
        ...state,
        status: { ...state.status, CASES_REPORT: "request" },
      };
      break;
    case customerConstants.CUSTOMER_GET_CASES_REPORT_SUCCESS:
      state = {
        ...state,
        status: { ...state.status, CASES_REPORT: "success" },
      };

      break;
    case customerConstants.CUSTOMER_GET_CASES_REPORT_FAILURE:
      state = {
        ...state,
        status: { ...state.status, CASES_REPORT: action.error },
      };
      break;

    // GET CUSTOMER CASE TAG
    case customerConstants.CUSTOMER_GET_CASE_TAG_REQUEST:
      state = {
        ...state,
        status: { ...state.status, CASE_TAGS: "request" },
      };
      break;
    case customerConstants.CUSTOMER_GET_CASE_TAG_SUCCESS:
      state = {
        ...state,
        case_tags: action.data,
        status: { ...state.status, CASE_TAGS: "success" },
      };

      break;
    case customerConstants.CUSTOMER_GET_CASE_TAG_FAILURE:
      state = {
        ...state,
        status: { ...state.status, CASE_TAGS: action.error },
      };
      break;

    // GET CUSTOMER CREDITS
    case customerConstants.CUSTOMER_GET_CREDITS_REQUEST:
      state = {
        ...state,
        status: { ...state.status, CREDITS: "request" },
      };
      break;
    case customerConstants.CUSTOMER_GET_CREDITS_SUCCESS:
      state = {
        ...state,
        credits: action.data,
        status: { ...state.status, CREDITS: "success" },
      };

      break;
    case customerConstants.CUSTOMER_GET_CREDITS_FAILURE:
      state = {
        ...state,
        credits: 0,
        status: { ...state.status, CREDITS: action.error },
      };
      break;

    // ADD CUSTOMER CREDITS
    case customerConstants.CUSTOMER_ADD_CREDITS_REQUEST:
      state = {
        ...state,
        status: { ...state.status, ADD_CREDITS: "request" },
      };
      break;
    case customerConstants.CUSTOMER_ADD_CREDITS_SUCCESS:
      state = {
        ...state,
        status: { ...state.status, ADD_CREDITS: "success" },
      };

      break;
    case customerConstants.CUSTOMER_ADD_CREDITS_FAILURE:
      state = {
        ...state,
        status: { ...state.status, ADD_CREDITS: action.error },
      };
      break;

    default:
      break;
  }
  return state;
}
